"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Home;
var _react = _interopRequireWildcard(require("react"));
var _Pdf = _interopRequireDefault(require("../../api/Pdf"));
var _SideBar = _interopRequireDefault(require("../SideBar/"));
var _styles = _interopRequireDefault(require("./styles"));
var _Reader = _interopRequireDefault(require("../Reader"));
var _ReaderNavigation = _interopRequireDefault(require("../ReaderNavigation"));
var _BottomNavigation = _interopRequireDefault(require("../BottomNavigation"));
var _TopBarMobile = _interopRequireDefault(require("../TopBarMobile"));
var _Auth = require("../../contexts/Auth");
var _Highlight = _interopRequireDefault(require("../../api/Highlight"));
var _Highlight2 = require("../../contexts/Highlight");
var _HighlightPopover = _interopRequireDefault(require("../HighlightPopover"));
var _HighlightList = require("../../contexts/HighlightList");
var _Theme = require("../../contexts/Theme");
var _Preference = _interopRequireDefault(require("../../api/Preference"));
var _Page = _interopRequireDefault(require("../../api/Page"));
var _CopyrightWarnDialog = _interopRequireDefault(require("../CopyrightWarnDialog/"));
var _CopyTextDialog = _interopRequireDefault(require("../CopyTextDialog"));
var _CopyLimitDialog = _interopRequireDefault(require("../CopyLimitDialog"));
var _Copy = require("../../constants/Copy");
var _Copy2 = _interopRequireDefault(require("../../services/Copy"));
var _Copy3 = require("../../contexts/Copy");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function Home() {
  var [file, setFile] = (0, _react.useState)();
  var [pdf, setPdf] = (0, _react.useState)();
  var [copyrigthWarnDialog, setCopyrigthWarnDialog] = (0, _react.useState)(false);
  var [copyDialog, setCopyDialog] = (0, _react.useState)(false);
  var [limitDialog, setLimitDialog] = (0, _react.useState)(false);
  var [highlight, setHighlight] = (0, _react.useState)();
  var [lastPage, setLastPage] = (0, _react.useState)();
  var [copyContent, setCopyContent] = (0, _react.useState)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    setFocus
  } = (0, _HighlightList.useHighlightList)();
  var {
    highlights,
    dispatch,
    ACTION,
    focus: highlightFocus,
    setFocus: setHighlightFocus
  } = (0, _Highlight2.useHighlight)();
  var {
    scale,
    theme,
    setScale,
    setTheme,
    THEME
  } = (0, _Theme.useTheme)();
  var {
    copyValue,
    setCopyValue
  } = (0, _Copy3.useCopy)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    var {
      applicationToken,
      sessionToken,
      uuid
    } = auth;
    _Pdf.default.getUrl(applicationToken, sessionToken, uuid).then(url => setFile(url));
  }, [auth]);
  (0, _react.useEffect)(() => {
    function getLastPage() {
      return _getLastPage.apply(this, arguments);
    }
    function _getLastPage() {
      _getLastPage = _asyncToGenerator(function* () {
        var {
          applicationToken,
          sessionToken,
          uuid,
          userId
        } = auth;
        var response = yield _Page.default.getPage(applicationToken, sessionToken, uuid, userId);
        setLastPage(Number(response.data.page));
      });
      return _getLastPage.apply(this, arguments);
    }
    getLastPage();
  }, [auth]);
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    setTimeout(() => {
      return pdf.viewer.currentPageNumber = lastPage;
    }, 1000);
  }, [lastPage, pdf]);
  (0, _react.useEffect)(() => {
    var {
      applicationToken,
      sessionToken,
      uuid,
      userId
    } = auth;
    _Highlight.default.getAll(applicationToken, sessionToken, uuid, userId).then(response => dispatch({
      type: ACTION.BATCH_CLEAR_INSERT,
      payload: response
    }));
  }, [auth, ACTION, dispatch]);
  (0, _react.useEffect)(() => {
    function loadPreferences() {
      return _loadPreferences.apply(this, arguments);
    }
    function _loadPreferences() {
      _loadPreferences = _asyncToGenerator(function* () {
        var {
          applicationToken,
          sessionToken,
          userId
        } = auth;
        var response = yield _Preference.default.get(applicationToken, sessionToken, userId);
        setScale(response.settings.font_size);
        setTheme(THEME[response.settings.background_style]);
      });
      return _loadPreferences.apply(this, arguments);
    }
    loadPreferences();
  }, [auth, THEME, setScale, setTheme]);
  function onSelectHighlight(highlight) {
    setHighlight({
      text_reference: highlight
    });
  }
  function handleCopyButtonClick(_x) {
    return _handleCopyButtonClick.apply(this, arguments);
  }
  function _handleCopyButtonClick() {
    _handleCopyButtonClick = _asyncToGenerator(function* (highlight) {
      var {
        applicationToken,
        sessionToken,
        userId,
        uuid
      } = auth;
      setCopyContent(highlight);
      var copyrightWarn = yield _Copy2.default.getCopyrightStatus(applicationToken, sessionToken, userId, uuid);
      if (copyValue >= 100) {
        setLimitDialog(true);
      } else if (copyrightWarn && copyValue < 100) {
        setCopyDialog(true);
      } else if (!copyrightWarn && copyValue < 100) {
        setCopyrigthWarnDialog(true);
      }
    });
    return _handleCopyButtonClick.apply(this, arguments);
  }
  function renderReader() {
    return /*#__PURE__*/_react.default.createElement(_Reader.default, {
      pdf: pdf,
      url: file,
      setPdf: setPdf,
      highlights: highlights.map(item => _objectSpread(_objectSpread({}, item), item.text_reference)),
      onSelection: onSelectHighlight,
      onClickHighlight: setFocus,
      scale: scale,
      containerStyle: {
        backgroundColor: theme.reader.backgroundColor
      },
      focus: _objectSpread(_objectSpread({}, highlightFocus), highlightFocus === null || highlightFocus === void 0 ? void 0 : highlightFocus.text_reference),
      setFocus: setHighlightFocus
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    style: {
      backgroundColor: theme.reader.backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_SideBar.default, {
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rightContainer
  }, file ? renderReader() : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loading,
    style: {
      color: theme.reader.color
    }
  }, "Carregando..."), /*#__PURE__*/_react.default.createElement(_HighlightPopover.default, {
    pdf: pdf,
    highlight: highlight,
    handleCopyButtonClick: handleCopyButtonClick,
    setHighlight: setHighlight,
    onDelete: highlight => dispatch({
      type: ACTION.DELETE,
      payload: highlight
    }),
    onUpdate: highlight => dispatch({
      type: ACTION.UPDATE,
      payload: highlight
    }),
    onInsert: highlight => dispatch({
      type: ACTION.INSERT,
      payload: highlight
    }),
    onAddNote: setFocus
  }), /*#__PURE__*/_react.default.createElement(_ReaderNavigation.default, {
    className: classes.navigation,
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement(_BottomNavigation.default, {
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement(_TopBarMobile.default, {
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement(_CopyrightWarnDialog.default, {
    pdf: pdf,
    copyContent: copyContent,
    setCopyContent: setCopyContent,
    copyDialog: copyDialog,
    setCopyDialog: setCopyDialog,
    copyrigthWarnDialog: copyrigthWarnDialog,
    setCopyrigthWarnDialog: setCopyrigthWarnDialog
  }), /*#__PURE__*/_react.default.createElement(_CopyTextDialog.default, {
    copyValue: copyValue,
    setCopyValue: setCopyValue,
    pdf: pdf,
    copyContent: copyContent,
    copyDialog: copyDialog,
    setCopyContent: setCopyContent,
    setCopyDialog: setCopyDialog,
    setCopyrigthWarnDialog: setCopyrigthWarnDialog,
    origin: _Copy.ORIGIN.READER
  }), /*#__PURE__*/_react.default.createElement(_CopyLimitDialog.default, {
    limitDialog: limitDialog,
    setLimitDialog: setLimitDialog
  })));
}